function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.05 10.14v1.16h3.26V8.05h-1.16c-1.16 0-2.1.94-2.1 2.09zm0 3.72c0 1.15.94 2.09 2.09 2.09h1.16V12.7H8.05v1.16zm4.65 2.09h1.16c1.15 0 2.09-.94 2.09-2.09V12.7H12.7v3.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2zm1.16 11.86a3.5 3.5 0 01-3.49 3.49h-3.72c-1.92 0-3.49-1.56-3.49-3.49v-3.72a3.5 3.5 0 013.49-3.49h3.72c1.92 0 3.49 1.56 3.49 3.49v3.72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.86 8.05H12.7v3.26h3.26v-1.16c-.01-1.16-.95-2.1-2.1-2.1z"
})));